<div class="btn-group btn-group-toggle" [ngClass]="toggleOptions[selectedOption]" data-toggle="buttons" id="toggle-button">
  <label class="btn btn-sm btn-secondary">
    <input class="btn-check" type="radio" name="options" id="optChecked" autocomplete="off" (click)="toggleHandler(toggleOptions.indexOf('checked'))"> {{toggleOptionsLabels.checked}}
  </label>
  <label class="btn btn-sm btn-secondary">
    <input class="btn-check" type="radio" name="options" id="optUnchecked" autocomplete="off" (click)="toggleHandler(toggleOptions.indexOf('unchecked'))"> {{toggleOptionsLabels.unchecked}}
  </label>
  
</div>